<template>
<div>
  <panel>
      <p slot="header">
          {{ item.name }} <span class="gray">(grupa)</span>
      </p>

      <p slot="actions">
          <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.email-groups.dashboard'})">Wróć</ui-button>
          <ui-button type="flat" icon="mode_edit" color="primary" @click="$router.push({name: 'admin.email-groups.edit', params: {id: id}})">Edytuj grupę</ui-button>
      </p>
      <table class="table info-table">
          <tr>
              <th class="short">
                  Grupa publiczna?
              </th>
              <td>
                  <span>{{ item.public ? 'Tak' : 'Nie' }}</span>
              </td>
          </tr>
          <tr>
              <th class="short">
                  Ilość subskrybentów
              </th>
              <td>
                  <span>{{ item.total_emails }}</span>
              </td>
          </tr>
          <tr>
              <th>
                  Status
              </th>
              <td>
                  {{ item.status ==1 ? 'Aktywna' : 'Nie aktywna' }}
              </td>
          </tr>
          <tr v-if="item.id">
              <th>
                  Konto
              </th>
              <td>
                  <a @click="$router.push({name: 'admin.accounts.show', params: {id: item.email_account.id}})">{{ item.email_account.name }}</a>
              </td>
          </tr>
      </table>
  </panel>

  <panel v-if="item.id && item.public">
      <p slot="header">
          Kod formularza do zapisywania się do tej grupy
      </p>

      <p>Element do umieszczenie w kodzie html strony tam gdzie chcemy aby pokazał się formularz</p>
      <p class="template-pre">
          {{ item.signup_form }}
      </p>

      <p>Element do umieszczenie w kodzie html strony na samym dole przed końcem znacznika body</p>
      <p class="template-pre">
          {{ item.signup_script }}
      </p>

  </panel>

  <panel v-if="item.id && item.public">
      <p slot="header">
          Dane formularza do zapisywania się do tej grupy
      </p>
      <p slot="actions">
          <ui-button color="primary" type="flat" @click="openPreviewFormPage">Podgląd formularza</ui-button>
      </p>

      <table class="table info-table">
          <tr>
              <th class="short">
                  Tytuł formularza
              </th>
              <td>
                  <span>{{ item.form_title ? item.form_title : '&mdash;' }}</span>
              </td>
          </tr>

          <tr>
              <th>
                  Wymagana zgoda (1)
              </th>
              <td>
                  <span>{{ item.user_agree ? 'Tak' : 'Nie' }}</span>
              </td>
          </tr>

          <tr>
              <th>
                  Wymagana zgoda (2)
              </th>
              <td>
                  <span>{{ item.user_agree2 ? 'Tak' : 'Nie' }}</span>
              </td>
          </tr>
      </table>
  </panel>


  <panel v-if="item.id && item.public">
      <p slot="header">
          Wiadomość e-mail z linkiem potwierdzającym
      </p>

      <table class="table info-table">
          <tr>
              <th class="short">
                  Dodatkowa treść
              </th>
              <td>
                  <span>{{ item.confirm_email_body ? item.confirm_email_body : '&mdash;' }}</span>
              </td>
          </tr>
      </table>
  </panel>


  <panel>
      <p slot="header">
          Adresy e-mail w tej grupie <span class="gray" v-if="meta.total">({{ meta.total }})</span>
      </p>

      <table class="table">
          <thead>
              <tr>
                  <th>
                      E-mail
                  </th>
                  <th>
                      Status
                  </th>
                  <th>
                      Zaimportowany
                  </th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="email in emails">
                  <td>
                      <a class="main-link" @click="$router.push({name: 'admin.emails.show', params: {id: email.id}})">{{ email.email }}</a>
                  </td>
                  <td>
                      <email-status :item="email" v-if="email"></email-status>
                  </td>
                  <td>
                      <p v-if="email.was_imported">
                          Tak. {{ email.imported_at_formated }}
                      </p>
                      <p v-if="!email.was_imported">
                          Nie
                      </p>
                  </td>
              </tr>
          </tbody>
      </table>

      <basic-pagination :meta="meta" @pagination-page="changePage" @pagination-limit="changeLimit"></basic-pagination>

  </panel>
</div>
</template>
<script>
import EmailGroups from './../../services/EmailGroups'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      meta: {
        current_page: 1,
        last_page: 0,
        total: 0,
        per_page: 10,
        sort: 'id',
        direction: 'desc',
        limits: [10, 20, 50, 100, 500],
        filter: {}
      },
      emails: [],
      pageUrl: '',
      item: EmailGroups.getBaseItem(),
      id: null
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.pageUrl = EmailGroups.signupPagePreviewUrl(this.id)
    this.getItem(this.id)
    this.getEmails(this.meta)
  },
  methods: {
    getEmails (meta) {
      this.setLoading(true)
      EmailGroups.inGroup(this.id, meta).then(res => {
        this.emails = res.data.items
        this.meta = res.data.meta
        this.setLoading(false)
      })
    },
    getItem (id) {
      this.setLoading(true)
      EmailGroups.get(id).then(res => {
        const item = EmailGroups.convertNulls(res.data.item)
        this.item = item
        this.setLoading(false)
      })
    },
    openPreviewFormPage () {
      window.open(this.pageUrl)
    },
    changePage (page) {
      this.meta.current_page = page
      this.getEmails(this.meta)
    },
    changeLimit (limit) {
      this.meta.per_page = limit
      this.meta.current_page = 1
      this.getEmails(this.meta)
    }
  }
}
</script>


// WEBPACK FOOTER //
// Show.vue?38f1520a